export default (function (alg, key) {
  if (alg.startsWith('RS') || alg.startsWith('PS')) {
    var modulusLength = key.algorithm.modulusLength;
    if (typeof modulusLength !== 'number' || modulusLength < 2048) {
      throw new TypeError("".concat(alg, " requires key modulusLength to be 2048 bits or larger"));
    }
  }
});